import FeatherIcon from "feather-icons-react";
import React from "react";
import { Link } from "react-router-dom";

const ExpenseInfo = () => {
  return (
    <div className="page-wrapper">
      <div className="content pt-0">
        <div className="d-flex justify-content-between my-3">
          {/* Left section with heading and description */}
          <div className="d-flex flex-column">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/crm/dashboard">
                    <i className="fas fa-home fa-lg" />
                  </Link>
                </li>
                <h4 className="breadcrumb-item " aria-current="page">
                  Expenses
                </h4>
              </ol>
            </nav>
            <p className="text-muted">Manage and add new Expenses here </p>
          </div>

          {/* Right section with buttons */}
          <div className="d-flex">
            <div className="me-3">
             
            </div>
            <div>
              <Link
                to="/crm/expenses"
                className="btn btn-secondary btn-sm"
         
              >
                <FeatherIcon icon="arrow-left" className="" />
                
              </Link>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="card-header">
            <ul className="nav nav-tabs nav-tabs-bottom mb-3">
              <li className="nav-item">
                <Link
                  className="nav-link active"
                  to="#Expense"
                  data-bs-toggle="tab"
                >
                  Expense
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="#Tasks" data-bs-toggle="tab">
                  Tasks
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="#Reminders" data-bs-toggle="tab">
                  Reminders
                </Link>
              </li>
            </ul>
            <hr />
            <div className="d-flex justify-content-between">
              <div className="">
                <h3>Petrol</h3>
                <p> Fuel for site visit Mar 21 - 27 Mar</p>
                <div className="d-flex">
                  <p className="me-2">Created by: </p>
                  <p className="text-info">Ajith Kumar</p>
                </div>
              </div>
             
            </div>
          </div>
          <div className="card-body">
            <div className="tab-content">
              <div className="tab-pane show active" id="Expense">
                <div className="d-flex">
                  <p className="me-2">Amount: </p>
                  <p className="text-info">Rs.1,150.00</p>
                </div>
                <div className="d-flex">
                  <p className="me-2">Date: </p>
                  <p className="text-info">28/03/2025</p>
                </div>
                <div className="d-flex">
                  <p className="me-2">Customer: </p>
                  <p className="text-info">Prudent Teqtis Pvt Ltd</p>
                </div>
                <div className="d-flex">
                  <p className="me-2">Project: </p>
                  <p className="text-info">Microsoft HYD-01</p>
                </div>
                <div className="d-flex">
                  <p className="me-2">Note: </p>
                  <p className="text-info">
                    Petrol expenses of site visit to HYD 01 from Mar 21st - 27th
                  </p>
                </div>
              </div>
              <div className="tab-pane" id="Tasks"></div>
              <div className="tab-pane" id="Reminders"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExpenseInfo;
